import {combineReducers} from 'redux'
import isResultReducer from "./isResultReducer"
import mainALLReducer from "./mainReducer"
//IndexImportHygen
const allMenuAuthorizationReducers = combineReducers({
    isResultReducer,
    mainALLReducer
    //IndexUsingHygen
})

export default allMenuAuthorizationReducers;